<template>
  <div class="preloader" :class="this.loading ? '': 'loading'">
    <div>
      <svg
        width="88"
        height="200"
        viewBox="0 0 88 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.7">
          <circle cx="43.5" cy="100.5" r="30" stroke="white" />
          <circle r="2" transform="matrix(1 0 0 -1 43.5 100.5)" fill="white" stroke="white" />
          <line x1="43.5" y1="2.18557e-08" x2="43.5" y2="200" stroke="white" />
        </g>
        <circle class="circle1" cx="65" cy="69" r="5" fill="white" />
        <circle cx="5" cy="131" r="5" fill="white" />
        <circle class="circle2" cx="15.5" cy="124.5" r="3.5" fill="white" />
        <circle class="circle3" cx="33" cy="139" r="5" fill="#FDC65A" />
        <circle cx="83" cy="100" r="5" fill="#FDC65A" />
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    loading: Boolean,
  },
};
</script>
<style lang="scss" scoped>
.preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: #f9faff;
  background: #15224e;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 1.5s cubic-bezier(1, 0.01, 1, 0.85) 1s;
  svg {
    height: 200px;
    width: 100px;
  }
  &.loading {
    transform: translateY(120vh);
  }
  .bubbles {
    position: relative;
    .bubble {
      display: inline-block;
      padding: 0px 5px;
      @for $i from 1 to 11 {
        &:nth-of-type(#{$i}) .circle {
          animation-delay: $i * 0.1s;
        }
      }
      .circle {
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 50%;
        background: $textBlue;
        background: #f9faff;
        animation: pulse 1.5s infinite;
        box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.3);
        box-shadow: 0px 0px 12px rgba($color: #fff, $alpha: 0.3);
      }
    }
  }
}

.circle1 {
  animation: circle1 1.5s reverse infinite;
}
.circle2 {
  animation: circle2 1.5s reverse infinite;
}
.circle3 {
  animation: circle3 1.5s reverse infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.2);
    opacity: 0.75;
  }
  100% {
    transform: scale(1);
  }
}

@keyframes circle1 {
  0% {
    transform: translate(-30px, 23px);
  }
  50% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-30px, 23px);
  }
}
@keyframes circle2 {
  0% {
    transform: translate(28px, -24px);
  }
  50% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(28px, -24px);
  }
}
@keyframes circle3 {
  0% {
    transform: translate(20px, 0);
  }
  50% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(20px, 0);
  }
}
</style>